export interface Rect {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface Viewport {
  width: number;
  height: number;
}

export const MIN_WIDTH = 640;
export const MIN_HEIGHT = 360;

/** Keeps at least a sliver of the title bar reachable, whatever the viewport size. */
export function clampToViewport(rect: Rect, viewport: Viewport): Rect {
  const w = Math.min(rect.w, viewport.width);
  const h = Math.min(rect.h, viewport.height);
  const x = Math.min(Math.max(rect.x, 0), Math.max(0, viewport.width - w));
  const y = Math.min(Math.max(rect.y, 0), Math.max(0, viewport.height - h));
  return { x, y, w, h };
}

export function applyDrag(rect: Rect, dx: number, dy: number, viewport: Viewport): Rect {
  return clampToViewport({ ...rect, x: rect.x + dx, y: rect.y + dy }, viewport);
}

export type ResizeEdge = 'n' | 's' | 'e' | 'w' | 'ne' | 'nw' | 'se' | 'sw';

export function applyResize(rect: Rect, edge: ResizeEdge, dx: number, dy: number, viewport: Viewport): Rect {
  let { x, y, w, h } = rect;

  if (edge.includes('e')) w = Math.max(MIN_WIDTH, rect.w + dx);
  if (edge.includes('s')) h = Math.max(MIN_HEIGHT, rect.h + dy);
  if (edge.includes('w')) {
    const newW = Math.max(MIN_WIDTH, rect.w - dx);
    x = rect.x + (rect.w - newW);
    w = newW;
  }
  if (edge.includes('n')) {
    const newH = Math.max(MIN_HEIGHT, rect.h - dy);
    y = rect.y + (rect.h - newH);
    h = newH;
  }

  return clampToViewport({ x, y, w, h }, viewport);
}

export function defaultRect(viewport: Viewport, kindIndex = 0): Rect {
  const w = Math.min(Math.max(viewport.width - 120, MIN_WIDTH), 1100);
  const h = Math.min(Math.max(viewport.height - 120, MIN_HEIGHT), 720);
  const offset = (kindIndex % 5) * 24;
  return clampToViewport({ x: 60 + offset, y: 40 + offset, w, h }, viewport);
}
